(() => {
  if (window.ocuzReviewsReady) return;
  window.ocuzReviewsReady = true;
  const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function initCarousel(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('[data-ocuz-track]');
    const slides = Array.from(root.querySelectorAll('[data-ocuz-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-ocuz-dot]'));
    if (!slides.length) return;
    let current = 0;
    const mark = index => { current = index; dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index))); };
    const move = index => {
      index = (index + slides.length) % slides.length;
      track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: motion()});
      mark(index);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => move(i)));
    root.querySelector('[data-ocuz-prev]').addEventListener('click', () => move(current - 1));
    root.querySelector('[data-ocuz-next]').addEventListener('click', () => move(current + 1));
    let frame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        let closest = 0, distance = Infinity;
        slides.forEach((slide, i) => {
          const diff = Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft);
          if (diff < distance) { closest = i; distance = diff; }
        });
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2 && track.scrollLeft > 0) closest = slides.length - 1;
        mark(closest);
      });
    }, {passive:true});
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(current + (e.key === 'ArrowRight' ? 1 : -1)); } });
    mark(0);
  }
  function initReviews(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const list = root.querySelector('[data-ocuz-list]');
    const reviews = Array.from(root.querySelectorAll('[data-ocuz-review]'));
    const select = root.querySelector('[data-ocuz-sort]');
    const pager = root.querySelector('[data-ocuz-pages]');
    const clear = root.querySelector('[data-ocuz-clear]');
    const size = Math.max(1, Number(root.dataset.pageSize) || 5);
    let page = 1, filter = 0, filtered = reviews;
    function render(focus) {
      filtered = reviews.filter(r => (!filter || Number(r.dataset.rating) === filter) && (select.value !== 'photos' || r.dataset.hasPhoto === 'true'));
      filtered.sort((a,b) => select.value === 'highest' ? Number(b.dataset.rating)-Number(a.dataset.rating)||Number(a.dataset.originalIndex)-Number(b.dataset.originalIndex) : select.value === 'lowest' ? Number(a.dataset.rating)-Number(b.dataset.rating)||Number(a.dataset.originalIndex)-Number(b.dataset.originalIndex) : Number(a.dataset.originalIndex)-Number(b.dataset.originalIndex));
      const pages = Math.max(1,Math.ceil(filtered.length/size));
      page = Math.min(Math.max(1,page),pages);
      reviews.forEach(r => r.hidden = true);
      filtered.forEach((r,i) => { list.appendChild(r); r.hidden = i < (page-1)*size || i >= page*size; });
      root.querySelector('[data-ocuz-empty]').hidden = filtered.length > 0;
      clear.hidden = !filter && select.value !== 'photos';
      root.querySelectorAll('[data-ocuz-filter]').forEach(b => b.setAttribute('aria-pressed',String(Number(b.dataset.ocuzFilter) === filter)));
      pager.replaceChildren();
      if (pages > 1) {
        const add = (text, target, label, disabled) => {
          const b = document.createElement('button');
          b.type = 'button'; b.textContent = text; b.setAttribute('aria-label',label); b.disabled = disabled;
          if (text === String(page)) b.setAttribute('aria-current','page');
          b.addEventListener('click',() => {page=target;render(true);});
          pager.appendChild(b);
        };
        add('‹',page-1,root.dataset.previousLabel,page===1);
        for(let i=1;i<=pages;i++) add(String(i),i,root.dataset.pageLabel+' '+i,false);
        add('›',page+1,root.dataset.nextLabel,page===pages);
      }
      root.querySelector('[data-ocuz-status]').textContent = root.dataset.pageLabel+' '+page+' / '+pages+' · '+filtered.length;
      if(focus && filtered.length) {
        const first = filtered[(page-1)*size];
        first.focus({preventScroll:true});
        first.scrollIntoView({behavior:motion(),block:'start'});
      }
    }
    select.addEventListener('change',() => {page=1;render(false);});
    root.querySelectorAll('[data-ocuz-filter]').forEach(b => b.addEventListener('click',() => {filter=Number(b.dataset.ocuzFilter)===filter?0:Number(b.dataset.ocuzFilter);page=1;render(false);}));
    clear.addEventListener('click',() => {filter=0;select.value='original';page=1;render(false);});
    root.addEventListener('shopify:block:select',e => {
      const selected=e.target.closest('[data-ocuz-review]');
      if(!selected)return;
      filter=0;select.value='original';page=Math.floor(reviews.indexOf(selected)/size)+1;render(false);
    });
    render(false);
  }
  function init(scope) {
    scope.querySelectorAll('[data-ocuz-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-ocuz-reviews]').forEach(initReviews);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
